













































import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  HistoryItem,
  Order,
  OrderDimensions,
  OrderStatus,
  OrderTransportMode
} from '@/interfaces/order.interface';
import {namespace} from 'vuex-class';
import {
  User,
  UserGroup
} from '@/interfaces/user.interface';
import {Company} from '@/interfaces/company.interface';

const ordersModule = namespace('orders');
const usersModule = namespace('users');

@Component
export default class OrderDetailsHistory extends Vue {
  @Prop({default: []}) order!: Order;
  @ordersModule.Action fetchHistory!: any;
  @ordersModule.State transportModes!: OrderTransportMode[];
  @ordersModule.State statuses!: OrderStatus[];
  @ordersModule.State orders!: Order[];
  @usersModule.State groups!: UserGroup[];
  @usersModule.State users!: User[];

  mounted() {
    this.fetchHistory({orderUuid: this.order.uuid});
  }

  get historyItems(): HistoryItem[] {
    const history = this.order && this.order.history || [];
    return [
      ...history.sort((a, b) => new Date(a.timestamp!) > new Date(b.timestamp!) ? -1 : 1),
      this.createdHistoryItem
    ];
  }


  get createdHistoryItem(): HistoryItem {
    return {
      user: this.order.createdBy,
      resourceName: 'order',
      resourceUuid: this.order.uuid,
      actionName: 'created',
      rowBefore: {},
      rowAfter: {},
      timestamp: this.order.createdAt
    };
  }

  getHistoryItems(before: object, after: object): any[] {
    const items: any[] = [];
    Object.keys(after).forEach(key => {
      let {value: valueBefore} = this.getValuesFromUuids(key, before);
      let {name, value: valueAfter} = this.getValuesFromUuids(key, after);
      items.push({
        propertyName: name || key,
        // @ts-ignore
        valueBefore: this.formatHistoryItem(name || key, valueBefore || before[key] || 'N/A'),
        // @ts-ignore
        valueAfter: this.formatHistoryItem(name || key, valueAfter || after[key] || 'N/A')
      });
    });
    return items;
  }

  private getValuesFromUuids(key: string, obj: any): { name: string, value: string | null } {
    const name = key.replace('_uuid', '');
    switch (name) {
      case 'transport_mode':
        return {name, value: this.getElementByUuid(this.transportModes, obj[key])};
      case 'status':
        return {name, value: this.getElementByUuid(this.statuses, obj[key])};
      case 'priority':
        return {name, value: this.getElementByUuid(this.statuses, obj[key])};
      case 'group':
        return {name, value: this.getElementByUuid(this.groups, obj[key])};
      case 'logistics_user':
        return {name, value: this.getElementByUuid(this.users, obj[key])};
      case 'shipper_company':
        return {name, value: this.getElementByUuid(this.companies, obj[key])};
      default:
        return {name, value: null};
    }
  }

  get companies(): Company[] {
    // @ts-ignore
    return this.orders.reduce((p: Company[], c: Order) => {
      // TODO: Remove duplicates
      return [
        ...p,
        c.shipper,
        c.consignee
      ];
    }, []);
  }

  private getElementByUuid(elements: any[], uuid: string) {
    const results = elements.find((i: any) => i.uuid === uuid);
    return results && results.name;
  }

  private formatHistoryItem(name: string, s: string | OrderDimensions[]) {
    if (!s) return '';
    if (name.endsWith('_user')) {
      const user: User | undefined = this.users.find(u => u.uuid === s);
      if (user) return `${user.firstName} ${user.lastName}`
    }
    if (typeof s === 'string') {
      return s.replace(/(<([^>]+)>)/ig, '');
    }
    if (name === 'dimensions') {
      const result: string[] = [];
      s.forEach((od: OrderDimensions) => {
        if (od.length && od.width && od.height && od.weight) {
          result.push(`${od.length}x${od.width}x${od.height} ${od.weight}kg`)
        }
      });
      return result.join(`, `)
    }
    return JSON.stringify(s);
  }
}
